import { Box, Row, Text } from 'native-base'
import { ListRenderItem, FlatList, StyleSheet, ScrollView } from 'react-native'

import { NFTCircle } from './NFTCircle'
import { Spacer } from './atoms/Spacer'

import { useCallback, useDeviceInfo, useTranslation } from '~hooks'
import { NftType } from '~types/nfts'

const NUMBER_OF_COLUMNS = 3

export const NFTsBar = ({ nftsList }: { nftsList: NftType[] }) => {
  const separateItem = useCallback(() => <Spacer x="4" />, [])
  const { shouldApplyDesktopStyles } = useDeviceInfo()
  const renderItem: ListRenderItem<NftType> = useCallback(({ item }) => {
    return <NFTCircle nft={item} key={item?.id} numOfColumns={NUMBER_OF_COLUMNS} />
  }, [])

  const HorizontalNFTView = useCallback(
    () => (
      <ScrollView>
        <Row flexWrap="wrap" w="full">
          {nftsList.map((item) => (
            <Box mr="4" key={item.id}>
              <NFTCircle nft={item} />
            </Box>
          ))}
        </Row>
      </ScrollView>
    ),
    [nftsList]
  )

  if (shouldApplyDesktopStyles) {
    return (
      <>
        <ListHeaderComponent />
        <HorizontalNFTView />
      </>
    )
  }
  return (
    <FlatList
      columnWrapperStyle={styles.columnWrapper}
      contentContainerStyle={styles.containerStyle}
      data={nftsList}
      ItemSeparatorComponent={separateItem}
      ListHeaderComponent={ListHeaderComponent}
      numColumns={NUMBER_OF_COLUMNS}
      renderItem={renderItem}
      showsHorizontalScrollIndicator={false}
    />
  )
}

const styles = StyleSheet.create({
  columnWrapper: {
    justifyContent: 'space-between',
  },
  containerStyle: {
    paddingBottom: 16,
    paddingHorizontal: 16,
  },
})

const ListHeaderComponent = () => {
  const { t } = useTranslation()

  return (
    <Box px="4" pb="3">
      <Text bold fontSize="lg">
        {t('wallet_screen.nfts')}
      </Text>
    </Box>
  )
}
